export default "__VITE_ASSET__DjtPj94$__"